import Vue from 'vue'
import VueRouter from 'vue-router'

import TokenService from "../services/token.service";
import AuthService from "../services/auth.service";
import IpadSimulation from "./ipad-simulation"
//import NProgress from "../assets/js/nprogress"
Vue.use(VueRouter);

/**
 * Route meta:
 * - public
 * - requiresLogout
 */

const router = new VueRouter({
    mode: 'history',
    scrollBehavior: () => ({y: 0}),
    routes: [
        {
            name: 'Dashboard',
            path: '/dashboard',
            component: () => import('@/pages/UnderConstruction')
        },
        {
            name: 'DashboardPage',
            path: '/dashboardPage',
            component: () => import('@/pages/Dashboard/DashboardPage')
        },
        ...IpadSimulation,
        {
            name: 'Efb',
            path: '/efb',
            component: () => import('@/pages/Efb/Efb'),
            meta: {
                requiredPermission: "Efb.Device"
            }
        },

        {
            name: 'EFBDevices',
            path: '/efbdevice/:device_uuid',
            component: () => import('@/pages/Efb/EFBDevices')
        },

        {
            name: 'EFBOccSideLogs',
            path: '/efbOccSideLogs',
            component: () => import('@/pages/Efb/EFBOccSideLogs'),
            meta: {
                requiredPermission: "Efb.OccLogs"
            }
        },

        {
            name: 'Flights',
            path: '/flights',
            component: () => import('@/pages/Flights/Flights'),
            meta: {
                requiredPermission: "Flights.View"
            }
        },

        {
            name: 'IpadMain',
            path: '/main-menu/:id/:kfnl/:legno',
            component: () => import('@/pages/IpadPreview/MainMenu')
        },

        // {
        //     name: 'Schedule',
        //     path: '/schedule/',
        //     component: () => import('@/pages/Schedule/Schedule'),
        //     meta: {
        //         requiredPermission: "Schedule.ViewAll"
        //     }
        // },

        {
            name: 'Schedule',
            path: '/schedule/:date',
            component: () => import('@/pages/Schedule/Schedule'),
            meta: {
                requiredPermission: "Schedule.ViewAll"
            }
        },
        {
            name: 'EditFlight',
            path: '/editflight/:id',
            component: () => import('@/pages/Schedule/EditFlight')
        },
        {
            name: 'CreateFlight',
            path: '/createflight/',
            component: () => import('@/pages/Schedule/CreateFlight')
        },
        {
            name: 'FlightPlaning',
            path: '/flightplaning/:id',
            component: () => import('@/pages/Flights/FlightPlaning')
        },
        {
            name: 'FlightFolderHistory',
            path: '/flightFolderHistory/:id/:kfnl/:legno',
            component: () => import('@/pages/Schedule/FlightFolderHistory')
        },

        {
            name: 'ReportSummaryHistory',
            path: '/ReportSummaryHistory/:IdIpadLKVOO', // IdIpadLKVOO
            component: () => import('@/pages/Admin/ReportSummary/ReportSummaryHistory')// ReportSummary/ReportSummaryHistory')
        },

        {
            name: 'Aircrafts',
            path: '/aircrafts',
            component: () => import('@/pages/Aircrafts/Aircrafts'),
            meta: {
                requiredPermission: "Aircraft.Full"
            }
        },

        {
            name: 'Library',
            path: '/library',
            target: '_blank',
            beforeEnter() {
                window.open("https://dms.corendonairlines.com/#step-1",
                    '_blank');
            }
        },

        {
            name: 'Timeline',
            path: '/timeline',
            component: () => import('@/pages/Timeline/Timeline'),

        },

        {
            name: 'Users',
            path: '/users',
            component: () => import('@/pages/Users/UserList'),
            meta: {
                requiredPermission: "Users.View"
            }
        },
        {
            name: 'UserDetails',
            path: '/userDetails',
            component: () => import('@/pages/Users/UserDetails'),
            meta: {
                requiredPermission: "Users.View"
            }
        },
        {
            name: 'UsersProfile',
            path: '/UsersProfile',
            component: () => import('@/pages/Users/UsersProfile')
        },
        {
            name: 'UserRoles',
            path: '/userRoles',
            component: () => import('@/pages/Users/UserRoles')
        },

        {
            name: 'Services',
            path: '/Services',
            component: () => import('@/pages/Services/Services'),
            meta: {
                requiredPermission: "Services.View"
            }
        },
        // {
        //     name: 'TechnicalHistory',
        //     path: '/technicalHistory',
        //     component: () => import('@/pages/Admin/TechnicalHistory/HistoryMain'),
        //     meta: {
        //         requiredPermission: "TechnicalHistory.Full"
        //     }
        // },

        {
            name: 'Airport',
            path: '/airportcontrol',
            component: () => import('@/pages/Admin/AirportControl/Airports'),
            meta: {
                requiredPermission: "Airport.Full"
            }
        },
        {
            name: 'WeatherMatrix',
            path: '/weathermatrix',
            component: () => import('@/pages/Admin/WeatherMatrix/WeatherMatrix'),
            meta: {
                requiredPermission: "WeatherMatrix.Full"
            }

        },

        {
            name: 'ReportSummary',
            path: '/reportsummary/:date',
            component: () => import('@/pages/Admin/ReportSummary/ReportSummary'),
            meta: {
                requiredPermission: "ReportSummary.Full"
            }

        },

        {
            name: 'ArchiveSummary',
            path: '/archivesummary',
            component: () => import('@/pages/Admin/ArchiveSummary/ArchiveSummary'),
            meta: {
                requiredPermission: "ArchiveSummary.Full"
            }

        },

        {
            name: 'testchart',
            path: '/testchart',
            component: () => import('@/pages/Admin/testchart'),
            meta: {
                requiredPermission: "WeatherMatrix.Full"
            }

        },

        {
            name: 'firs',
            path: '/firs',
            component: () => import('@/pages/Admin/FIRs/FIRs'),
            meta: {
                requiredPermission: "FIRs.Full"
            }

        },

        {
            name: 'Notifications',
            path: '/Notifications',
            component: () => import('@/pages/Admin/Notifies/Notifies'),
            meta: {
                requiredPermission: "Notifications.Full"
            }

        },

        {
            name: 'IpadUserList',
            path: '/IpadUserList',
            component: () => import('@/pages/Admin/IpadUsers/IpadUserList'),
            meta: {
                requiredPermission: "IpadUsers.Full"
            }
        },
        {
            name: 'WXBriefingGenerator',
            path: '/WXBriefingGenerator',
            component: () => import('@/pages/Admin/WXBriefingGenerator/WXBriefingGenerator.vue')
        },

        {
            name: 'Login',
            path: '/login',
            component: () => import('@/pages/Auth/Login'),
            meta: {
                public: true,
                requiresLogout: true
            }
        },
        {
            path: "/",
            redirect: "/dashboardPage"
        },
        {
            name: "Forbidden",
            path: "/403",
            component: () => import('@/pages/Forbidden')
        }
    ]
});

router.beforeEach((to, from, next) => {
    const isPublic = to.matched.some(r => r.meta.public);
    const requiresLogout = to.matched.some(r => r.meta.requiresLogout);
    const requiredPermission = to.matched[0].meta.requiredPermission;

    const isAuthenticated = !!TokenService.getAccessToken();

    if (!isPublic && !isAuthenticated) {
        return next({
            name: 'Login',
            query: {redirect: to.fullPath}
        });
    }


    if (isAuthenticated && requiresLogout) {
        return next('/');
    }

    if (requiredPermission && !AuthService.hasPermission(requiredPermission)) {
        return next('/403');
    }

    next();
});



export default router
